import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { map, shareReplay} from 'rxjs/operators';

import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';
import { LocalStorageUtil } from '~shared/utils/localstorage.util';
import {
  CART_UPDATE_LOCAL_STORAGE_FEATURE_KEY,
} from '~shared/constants/localstorage.constant';
import { FF_CART_UPDATE } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class CartFeatureService {
  public isCartUpdateFeatureEnabled: Observable<boolean>;

  constructor(
    private activeFeaturesConfigcatService: ActiveFeaturesConfigcatService
  ) {
    this.isCartUpdateFeatureEnabled = this.activeFeaturesConfigcatService
      .isFeatureEnabled(FF_CART_UPDATE)
      .pipe(
        map((isEnabled) => isEnabled || this.isCartUpdateLocalStorageEnabled()),
        shareReplay(1),
      );
  }

  private isCartUpdateLocalStorageEnabled(): boolean {
    return LocalStorageUtil.isFeatureEnabled(CART_UPDATE_LOCAL_STORAGE_FEATURE_KEY);
  }
}
